import Vue from 'vue'
import index from './layout/index.vue'
import router from '@/router/router.js';
import store from '@/store/index.js';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/theme/index.css'

router.afterEach(() => {
	window.scrollTo(0,0);
})

import AxiosPlugin from '@/unit/axios';

import {eltips} from '@/unit/eltips';
Vue.prototype.$eltips= eltips

import * as util from '@/unit/util';
Vue.prototype.$util= util

import plugins from './components/common/index.js'
Vue.use(plugins)

import  * as tim from '@/unit/tim/tim.js'
Vue.prototype.tim = tim.tim

import TencentCloudChat from '@tencentcloud/chat';
Vue.prototype.$TIM = TencentCloudChat		

import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
Vue.prototype.dayjs = dayjs


Vue.use(ElementUI);
Vue.use(AxiosPlugin);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(index),
}).$mount('#app')
